// test324
(324 && 0);
